import logoImage from "/assets/images/logo.png";

import heroImg from "/assets/images/test.png"
import welcomeImg from "/assets/images/welcome.jpg";
import greenImg from "/assets/images/green.jpg";
import goldImg from "/assets/images/gold.png";
import fussbadImg from "/assets/images/fussbad.png";
import lackImg from "/assets/images/lack.jpg";
import wellnessImg from "/assets/images/wellness.png";
import fussImg from "/assets/images/fuss.png";
import aromaImg from "/assets/images/aroma.png";
import gesichtsbehandlungImg from "/assets/images/gesichtsbehandlung.png";
import hotstoneImg from "/assets/images/hotstone.png";
import tiefgewebeImg from "/assets/images/tiefgewebe.png";
import manicureImg from "/assets/images/manicure.png";
import landingImg from "/assets/images/landing.jpg";
import placeholderImage from "/assets/images/placeholder.jpeg";
import oneImage from "/assets/images/1.jpeg";
import twoImg from "/assets/images/2.jpeg";
import threeImg from "/assets/images/3.jpeg";
import fourImg from "/assets/images/4.jpeg";
import fiveImg from "/assets/images/5.jpeg";
import p1Img from "/assets/images/p1.jpeg";
import p2Img from "/assets/images/p2.jpeg";
import p3Img from "/assets/images/p3.jpeg";

export const logo = logoImage;

export const hero = heroImg;
export const welcome = welcomeImg;
export const green = greenImg;
export const gold = goldImg;
export const fussbad = fussbadImg;
export const wellness = wellnessImg;
export const lack = lackImg;
export const fuss = fussImg;
export const aroma = aromaImg;
export const gesichtsbehandlung = gesichtsbehandlungImg;
export const hotstone = hotstoneImg;
export const tiefgewebe = tiefgewebeImg;
export const manicure = manicureImg;
export const landing = landingImg;
export const placeholder = placeholderImage;
export const one = oneImage;
export const two = twoImg;
export const three = threeImg;
export const four = fourImg;
export const five = fiveImg;
export const p1 = p1Img;
export const p2 = p2Img;
export const p3 = p3Img;